import styled from 'styled-components';

import { 
  FaExclamationTriangle
} from 'react-icons/fa';

const ErroLoadData = () => (
    <div style={{ textAlign: 'center', padding: '40px' }}>
        <FaExclamationTriangle style={{ fontSize: '48px', color: '#ef4444', marginBottom: '16px' }} />
        <h2>Erro ao carregar dados</h2>
        <p>Não foi possível carregar os dados do perfil. Tente novamente.</p>
    </div>
);

export default ErroLoadData;

